import {
  USER_SET_TOKEN_DATA,
  API_REQUEST,
  AUCTIONS_FETCH_ACTIVE_TABS,
  SEND_VISITOR_INFO,
  APP_AUCTIONS_GET_PUSH_NOTIFICATION_TOKEN,
  AUCTIONS_HIGHEST_BID_CHANGED,
  APP_INCOMING_MESSAGE,
  GET_APP_DATA,
  APP_NOTIFICATION_REFRESH_TOKEN,
  USER_SIGN_AGREEMENT,
  GET_RECENTLY_ITEMS,
  SEND_VISITOR_EMAIL,
  USER_SET_NEW_TOKEN_DATA
} from 'constants/action-types';

export function setTokenData(data) {
  return {
    type: USER_SET_TOKEN_DATA,
    payload: data
  };
}

export function setNewTokenData(data) {
  return {
    type: USER_SET_NEW_TOKEN_DATA,
    payload: data
  };
}

export function fetchTabs() {
  return {
    type: API_REQUEST,
    payload: {
      url: `/public/listings/tabs`,
      method: 'GET',
      nextActionType: AUCTIONS_FETCH_ACTIVE_TABS
    }
  };
}

export function sendVisitor(data) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/public/Visitors`,
      method: 'POST',
      nextActionType: SEND_VISITOR_INFO,
      data
    }
  };
}

export function sendToRegisterVisitors(data) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/public/Visitors/Registration`,
      method: 'POST',
      nextActionType: SEND_VISITOR_INFO,
      data
    }
  };
}

export function getAuctionsPushNotificationToken() {
  return {
    type: API_REQUEST,
    payload: {
      url: '/public/auctions/Notifications/Token/JTA/jta-listing',
      method: 'get',
      nextActionType: APP_AUCTIONS_GET_PUSH_NOTIFICATION_TOKEN
    }
  };
}

export function OnHighestBidChanged(msg) {
  return {
    type: AUCTIONS_HIGHEST_BID_CHANGED,
    payload: msg
  };
}

export function onIncomingMessage(msg) {
  return {
    type: APP_INCOMING_MESSAGE,
    payload: msg
  };
}

export function getAppData() {
  return {
    type: GET_APP_DATA
  };
}

export function scheduleRefreshNotificationToken(timeout, channelName, token) {
  return {
    type: APP_NOTIFICATION_REFRESH_TOKEN,
    payload: {
      timeout,
      channelName,
      token
    }
  };
}

export function signBuyerAgreement() {
  return {
    type: API_REQUEST,
    payload: {
      url: '/ApprovedBidders/SignAgreement',
      method: 'POST',
      nextActionType: USER_SIGN_AGREEMENT
    }
  };
}

export function getRecentlyItems(data) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/public/listings/Base`,
      method: 'POST',
      data,
      nextActionType: GET_RECENTLY_ITEMS
    }
  };
}

export function sendVisitorsEmail(data) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/public/EmailRegistration`,
      method: 'POST',
      data,
      nextActionType: SEND_VISITOR_EMAIL
    }
  };
}
